// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _default;
    }
});
var _react = /*#__PURE__*/ _interop_require_wildcard(require("react"));
var _RedEnvelopeTwoTone = /*#__PURE__*/ _interop_require_default(require("@ant-design/icons-svg/lib/asn/RedEnvelopeTwoTone"));
var _AntdIcon = /*#__PURE__*/ _interop_require_default(require("../components/AntdIcon"));
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interop_require_wildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
        return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
        return {
            default: obj
        };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
        return cache.get(obj);
    }
    var newObj = {
        __proto__: null
    };
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj){
        if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
            if (desc && (desc.get || desc.set)) {
                Object.defineProperty(newObj, key, desc);
            } else {
                newObj[key] = obj[key];
            }
        }
    }
    newObj.default = obj;
    if (cache) {
        cache.set(obj, newObj);
    }
    return newObj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var RedEnvelopeTwoTone = function(props, ref) {
    return /*#__PURE__*/ _react.createElement(_AntdIcon.default, _object_spread_props(_object_spread({}, props), {
        ref: ref,
        icon: _RedEnvelopeTwoTone.default
    }));
};
/**![red-envelope](data:image/svg+xml;base64,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) */ var RefIcon = /*#__PURE__*/ _react.forwardRef(RedEnvelopeTwoTone);
if (process.env.NODE_ENV !== 'production') {
    RefIcon.displayName = 'RedEnvelopeTwoTone';
}
var _default = RefIcon;
